import React from 'react';
import c from 'classnames';

export default function IconBrowserGoogle(props: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 460 460"
            xmlSpace="preserve"
            className={c('fill-current', props.className)}
        >
            <path
                fill="#ecf0f1"
                d="M60.438 68.311v227.442c0 15.095 12.237 27.332 27.332 27.332h344.898c15.095 0 27.332-12.237 27.332-27.332V68.311H60.438z"
            />
            <path
                fill="#d2d7d8"
                d="M460 38.153c0-15.095-12.237-27.332-27.332-27.332H87.77c-15.095 0-27.332 12.237-27.332 27.332V68.31H460V38.153z"
            />
            <path
                fill="#e67e22"
                d="M110.803 48.776H90.657a7.735 7.735 0 1 1 0-15.47h20.146a7.735 7.735 0 1 1 0 15.47zm50.365 0h-20.146a7.735 7.735 0 1 1 0-15.47h20.146a7.735 7.735 0 1 1 0 15.47z"
            />
            <path
                fill="#8fa6b4"
                d="M399.562 138.883c0-15.095-12.237-27.332-27.332-27.332H27.332C12.237 111.551 0 123.788 0 138.883v31.53h399.562v-31.53z"
            />
            <path
                fill="#acbdc6"
                d="M0 170.413v226.069c0 15.095 12.237 27.332 27.332 27.332H372.23c15.095 0 27.332-12.237 27.332-27.332V170.413H0z"
            />
            <path
                fill="#d0d5d9"
                d="M380.309 170.413v205.106c0 15.095-12.237 27.332-27.332 27.332H8.079c-2.624 0-5.159-.377-7.561-1.068 2.469 12.557 13.533 22.031 26.814 22.031H372.23c15.095 0 27.332-12.237 27.332-27.332V170.413h-19.253z"
                opacity=".49"
            />
            <path
                fill="#ffcd02"
                d="M50.365 149.506H30.219a7.735 7.735 0 1 1 0-15.47h20.146a7.735 7.735 0 1 1 0 15.47zm50.365 0H80.584a7.735 7.735 0 1 1 0-15.47h20.146a7.735 7.735 0 1 1 0 15.47z"
            />
            <path
                fill="#ffcf6d"
                d="M251.825 230.09H40.292a7.735 7.735 0 1 1 0-15.47h211.533a7.735 7.735 0 1 1 0 15.47zm30.219 60.438H40.292a7.735 7.735 0 1 1 0-15.47h241.752a7.735 7.735 0 1 1 0 15.47zm-20.146 90.657H40.292a7.735 7.735 0 1 1 0-15.47h221.606a7.735 7.735 0 1 1 0 15.47zm-100.73-120.876H40.292a7.735 7.735 0 1 1 0-15.47h120.876a7.735 7.735 0 1 1 0 15.47zm50.365 60.438H40.292a7.735 7.735 0 1 1 0-15.47h171.241a7.735 7.735 0 1 1 0 15.47zm-20.146 30.219H40.292a7.735 7.735 0 1 1 0-15.47h151.095a7.735 7.735 0 1 1 0 15.47z"
            />
            <path d="M378.341 372.673h66.454c.343 2.998.522 6.075.522 9.221 0 21.292-7.633 39.22-20.856 51.4-11.565 10.677-27.398 16.938-46.276 16.938-38.628.018-69.948-31.299-69.935-69.927-.017-38.631 31.304-69.952 69.935-69.935 18.847 0 34.68 6.931 46.79 18.216l-11.386 11.378c-9.018-8.715-21.207-14.018-35.248-14.018-41.966 0-68.194 45.429-47.211 81.773a54.516 54.516 0 0 0 47.211 27.257c27.46 0 47.849-20.311 51.221-46.727h-51.221v-15.576Z" />
        </svg>
    );
}
